import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Button from '@mui/material/Button';
import Headers from '../Layouts/Headers'
import { config } from '../_helpers/global'
import Footers from '../Layouts/Footers';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';

class AdminDashboard extends Component {

    componentDidMount() {
        //remove loader
        document.getElementById("LoadingModal").style.display = "none";
    }
    render() {
        return (
            <div>
                <Headers />
                <main>
                    <div className='container homecontainer'>
                        <div className='row'>
                            <div className='center full-width'>
                                <Paper variant="" sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}>
                                    <h1 className='color-blue'> Hargeisa Obstetrics and Gynecology Department </h1>
                                </Paper>
                            </div>
                            <div className='full-width'>
                                <div className='row center'>
                                    <div className=''>
                                        <a className="navbar-brand" href='/add/procedure/cost'>
                                            <Card className="dashboardcards center" variant="outlined">
                                                <CardActionArea>
                                                    <div className='full-width center pt-4'>
                                                        <CardMedia className=' dashboard icons fa fa-plus color-blue'
                                                            component="icon"
                                                            alt="Triage"
                                                        />
                                                    </div>
                                                    <CardContent>
                                                        <Typography gutterBottom variant="h5" className="center" component="div" >
                                                            Add Procedure Costs
                                                        </Typography>
                                                    </CardContent>
                                                </CardActionArea>
                                            </Card>
                                        </a>
                                    </div>


                                    <div className=''>
                                        <a className="navbar-brand" href='/confirm/staff/member'>
                                            <Card className="dashboardcards center" variant="outlined">
                                                <CardActionArea>
                                                    <div className='full-width center pt-4'>
                                                        <CardMedia className='fa dashboard icons fa-user-plus color-blue'
                                                            component="icon"
                                                            alt="Triage"
                                                        />
                                                    </div>
                                                    <CardContent>
                                                        <Typography gutterBottom variant="h5" className="center" component="div" >
                                                            Verify Users
                                                        </Typography>
                                                    </CardContent>
                                                </CardActionArea>
                                            </Card>
                                        </a>
                                    </div>
                                     <div className=''>
                                    <a className="navbar-brand" href='/all/staff/members'>
                                        <Card className="dashboardcards center" sx="{{maxWidth: 200}}" variant="outlined">
                                            <CardActionArea classes='dashboardcardsinner'>
                                                <div className='full-width center pt-4'>
                                                    <CardMedia className='fa dashboard icons fa-user color-blue'
                                                        component="icon"
                                                        alt="Triage"
                                                    />
                                                </div>
                                                <CardContent>
                                                    <Typography gutterBottom variant="h5" component="div" className="center">
                                                        All Staff Members
                                                    </Typography>
                                                </CardContent>
                                            </CardActionArea>
                                        </Card>
                                    </a>
                                </div>
                                     <div className=''>
                                    <a className="navbar-brand" href='/all/active/patients'>
                                        <Card className="dashboardcards center" sx="{{maxWidth: 200}}" variant="outlined">
                                            <CardActionArea classes='dashboardcardsinner'>
                                                <div className='full-width center pt-4'>
                                                    <CardMedia className='fa dashboard icons fa-user color-blue'
                                                        component="icon"
                                                        alt="Triage"
                                                    />
                                                </div>
                                                <CardContent>
                                                    <Typography gutterBottom variant="h5" component="div" className="center">
                                                        All Active Visit Patients
                                                    </Typography>
                                                </CardContent>
                                            </CardActionArea>
                                        </Card>
                                    </a>
                                </div>
                                     <div className=''>
                                    <a className="navbar-brand" href='/administrator/cms'>
                                        <Card className="dashboardcards center" sx="{{maxWidth: 200}}" variant="outlined">
                                            <CardActionArea classes='dashboardcardsinner'>
                                                <div className='full-width center pt-4'>
                                                    <CardMedia className='fa dashboard icons fa-user color-blue'
                                                        component="icon"
                                                        alt="Triage"
                                                    />
                                                </div>
                                                <CardContent>
                                                    <Typography gutterBottom variant="h5" component="div" className="center">
                                                        CMS
                                                    </Typography>
                                                </CardContent>
                                            </CardActionArea>
                                        </Card>
                                    </a>
                                </div>
                                </div>
                            </div >
                        </div >
                    </div >
                </main>
                <Footers></Footers>
            </div >
        )
    }
}

export default AdminDashboard
